var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDownActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web---Driver-Portal",
    transform: "translate(-4914.000000, -3745.000000)",
    fill: "#0B8888",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Templates-/-Cells-/-Tax-Forms---Mobile",
    transform: "translate(4587.000000, 3710.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(327.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.38164706,0 0,5.38164706 0,12 C0,18.6183529 5.38164706,24 12,24 C18.6183529,24 24,18.6183529 24,12 C24,5.38164706 18.6183529,0 12,0 Z M12,22.5882353 C6.16094118,22.5882353 1.41176471,17.8390588 1.41176471,12 C1.41176471,6.16094118 6.16094118,1.41176471 12,1.41176471 C17.8390588,1.41176471 22.5882353,6.16094118 22.5882353,12 C22.5882353,17.8390588 17.8390588,22.5882353 12,22.5882353 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "12.7058824 16.1675294 12.7058824 5.56235294 11.2941176 5.56235294 11.2941176 16.1562353 8.91105882 13.5247059 7.86635294 14.4734118 12 19.0418824 16.1618824 14.4734118 15.1171765 13.5247059"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownActive);
export default __webpack_public_path__ + "static/media/arrow-down-active.69c9cf43db881d9aaa52233dd3dd019a.svg";
export { ForwardRef as ReactComponent };